import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Input } from "common/InputForm";
import { CustomButton } from "components/form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import { editProductApi, productDetailApi } from "services/product";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import Form from "./Form";
import {
  masterBrandListApi,
  masterClothingCategoriesListApi,
  masterColorApi,
  masterSizeApi,
} from "services/master";
import useFullPageLoader from "common/UseFullPageLoader";

const EditWebProduct = () => {
  const navigate = useNavigate();
  const buttonRef = useRef();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [sizeList, setSizeList] = useState([]);
  const [showSize, setShowSize] = useState(false);
  const [sizeType, setSizeType] = useState("");

  const [loader, onShow, onHide] = useFullPageLoader();

  const [selectedOptions, setSelectedOptions] = useState({
    height: [],
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
    occasionName: [],
    availableSizes: [],
    category: "",
    brand: "",
    colorName: "",
  });

  const multiSelectValueHandler = (projectObject) => {
    const extractValue = [
      "height",
      "paletteName",
      "bodyShape",
      "styleIdentity",
      "flauntParts",
      "downplayParts",
      "occasionName",
      "availableSizes",
    ];

    const dummySelectedValue = {};

    extractValue.forEach((key) => {
      if (key === "occasionName") {
        dummySelectedValue["occasionName"] = projectObject["occasion"].map(
          (item) => ({ value: item, label: item })
        );
      } else if (key === "availableSizes") {
        dummySelectedValue["availableSizes"] = projectObject["sizes"].map(
          (item) => ({ value: item, label: item })
        );
      } else if (Array.isArray(projectObject[key])) {
        dummySelectedValue[key] = projectObject[key].map((item) => ({
          value: item,
          label: item,
        }));
      } else {
        dummySelectedValue[key] = [];
      }
    });
    return dummySelectedValue;
  };

  const validateForm = () => {
    const newErrors = {};
    if (selectedOptions?.height?.length === 0)
      newErrors.height = "Height is required";
    if (selectedOptions?.paletteName?.length === 0)
      newErrors.paletteName = "Palette Name is required";
    if (selectedOptions?.flauntParts?.length === 0)
      newErrors.flauntParts = "Flaunt parts is required";
    if (selectedOptions?.downplayParts?.length === 0)
      newErrors.downplayParts = "Downplay parts is required";
    if (selectedOptions?.occasionName?.length === 0)
      newErrors.occasionName = "Occasion name is required";
    if (selectedOptions?.category?.length === 0)
      newErrors.category = "Category name is required";
    if (!selectedOptions?.colorName || selectedOptions?.colorName?.length === 0)
      newErrors.colorName = "color name is required";
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const [errors, setErrors] = useState({});

  const fetchProductDetails = async () => {
    try {
      onShow();
      const { data } = await productDetailApi(id);
      const product = data?.data?.product || {};

      setSelectedOptions({
        ...multiSelectValueHandler(product),
        category: product.category || "",
        brand: product.brand?._id || "",
        colorName: product.color || {},
      });
      const category = product?.category;

      if (category === "Shoes") {
        setSizeType("shoes");
        setShowSize(false);
      } else if (
        ["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(
          category
        )
      ) {
        setSizeType("clothes");
        setShowSize(false);
      } else {
        setSizeType(category?.toLowerCase() || ""); // Optional default
        setShowSize(true); // Or false depending on your logic
      }
    } catch (error) {
      toastMessage(error.message, "error", "ProductDetails");
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchProductDetails();
  }, [id]);

  // const handleImageRemove = () => {
  //   setFormData((prevData) => ({ ...prevData, image: "", imageName: null }));
  // };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.title) newErrors.title = "Title is required";
  //   if (!formData.description)
  //     newErrors.description = "Description is required";
  //   if (!formData.price) newErrors.price = "Price is required";
  //   if (!formData.bodyShape) newErrors.bodyShape = "Body Shape is required";
  //   if (!formData.styleIdentity)
  //     newErrors.styleIdentity = "Style Identity is required";
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;
  //   setIsLoading(true);
  //   try {
  //     const formDatas = new FormData();
  //     formDatas.append("id", formData.id);
  //     formDatas.append("title", formData.title);
  //     formDatas.append("description", formData.description);
  //     formDatas.append("price", formData.price);
  //     formDatas.append("heightFit", formData.heightFit);
  //     formDatas.append("heightInch", formData.heightInch);
  //     formDatas.append("bodyShape", formData.bodyShape);
  //     formDatas.append("styleIdentity", formData.styleIdentity);
  //     // formDatas.append("flauntParts", formData.flauntParts.split(",").map((part) => part.trim()));
  //     // formDatas.append("downplayParts", formData.downplayParts.split(",").map((part) => part.trim()));
  //     formDatas.append("brandId", formData.brandId);
  //     formDatas.append("categoryId", formData.categoryId);
  //     formDatas.append("productId", formData.productId);
  //     if (formData.imageName) formDatas.append("image", formData.imageName);

  //     const res = await editProductApi(formDatas);
  //     if (res?.status === 200) {
  //       toastMessage(res?.message, "success", "EditProduct");
  //       navigate(-1);
  //     }
  //   } catch (error) {
  //     toastMessage(error.message, "error", "EditProduct");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);

    try {
      let payLoad = {
        productId: id,
        productType: "scrape",
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        occasion: selectedOptions.occasionName?.map((item) => item.value),
        categoryId: selectedOptions.category,
        color: selectedOptions.colorName,
        brandId: selectedOptions.brand,
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        height: selectedOptions.height?.map((item) => item.value),
        sizes: selectedOptions.availableSizes?.map((item) => item.value),
      };
      const formDatas = new FormData();
      formDatas.append("productId", payLoad.productId);
      formDatas.append("productType", payLoad.productType);
      formDatas.append("paletteName", JSON.stringify(payLoad.paletteName));
      formDatas.append("occasion", JSON.stringify(payLoad.occasion));

      formDatas.append("color", JSON.stringify(payLoad.color));

      formDatas.append("bodyShape", JSON.stringify(payLoad.bodyShape));
      formDatas.append("styleIdentity", JSON.stringify(payLoad.styleIdentity));
      formDatas.append("flauntParts", JSON.stringify(payLoad.flauntParts));
      formDatas.append("downplayParts", JSON.stringify(payLoad.downplayParts));
      formDatas.append("height", JSON.stringify(payLoad.height));
      formDatas.append("sizes", JSON.stringify(payLoad.sizes));
      if (payLoad?.brandId) {
        formDatas.append("brandId", payLoad.brandId);
      }
      if (payLoad?.categoryId) {
        formDatas.append("categoryId", payLoad.categoryId);
      }
      const res = await editProductApi(formDatas);
      if (res?.status === 200) {
        setErrors({});
        setSelectedOptions({
          height: [],
          paletteName: [],
          bodyShape: [],
          styleIdentity: [],
          flauntParts: [],
          downplayParts: [],
          occasionName: [],
          availableSizes: [],
          category: "",
          brand: "",
          colorName: "",
        });
        toastMessage(res?.data?.message, "success", "EditProduct");
        navigate("/product-management/scrape");
      }
    } catch (error) {
      toastMessage(error.message, "error", "EditProduct");
    } finally {
      setIsLoading(false);
    }
  };

  const sizeListHandler = async (type = sizeType) => {
    try {
      const res = await masterSizeApi({ type });

      if (res?.data?.status === 200) {
        const sizeOptions = res.data?.data?.sizes.map((size) => ({
          value: size.name,
          label: size.name,
        }));
        setSizeList(sizeOptions);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };

  useEffect(() => {
    fetchProductDetails();
  }, [id]);

  useEffect(() => {
    sizeListHandler();
  }, [sizeType]);

  return (
    <div className="editProduct">
      {loader}
      <div className="dashboard_title has_child">
        <h3>
          <Link to={`/product-management/scrape`}>
            <IoMdArrowRoundBack />
          </Link>
          Edit Product
        </h3>
        <CustomButton onClick={handleSubmit} isLoading={isLoading}>
          Update
        </CustomButton>
      </div>

      <div className="card">
        <div className="card-body">
          <Form
            {...{
              selectedOptions,
              setSelectedOptions,
              errors,
              setErrors,
              sizeType,
              setSizeType,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EditWebProduct;
